export default __webpack_public_path__ + "static/media/weprofile-300-old.cc15ed8c.png";